'use strict';

import React from 'react';
import { Popover, Button, OverlayTrigger } from 'react-bootstrap';
import Tooltips from './TooltipCollection';

/*
 * 
 *  Include example
 *  
 *  <Tooltip name="termin-datum" />
 *  <Tooltip name="termin-datum" placement="top" />
 *  <Tooltip title="Titel" text="Beschreibung..." />
 * 
 */

function TooltipElement({ name, placement, title, text }) {
    let tooltipPlacement = placement || "top";
    let tooltipTitle, tooltipText;

    let foundTooltip = Tooltips.find(t => t.name == name);

    if (foundTooltip) {
        tooltipTitle = foundTooltip.title;
        tooltipText = foundTooltip.text;
    }
    else {
        tooltipTitle = "Unbekannt";
        tooltipText = "Unbekannt";
    }

    tooltipTitle = title || tooltipTitle;
    tooltipText = text || tooltipText;

    const popover = (
        <Popover id="popover-basic">
            <Popover.Header as="h3">{tooltipTitle}</Popover.Header>
            <Popover.Body>
                {tooltipText}
            </Popover.Body>
        </Popover>
    );

    return <OverlayTrigger placement={tooltipPlacement} overlay={popover}>
        <Button size="sm" variant="link" className="button-tooltip p-0 mx-1"><i className="far fa-lg fa-question-circle"></i></Button>
    </OverlayTrigger>;
}

export default TooltipElement;